export const homeHandler = {
    pathPattern: '/brands/:brandId/home',
    toWeb: ({ brandId }) => ({ path: `/brands/${brandId}/home` }),
    // Location-less: Hestia expands `<brandId>/home` to the recipient's current location.
    toNative: ({ brandId }) => `/${brandId}/home`,
    scopedToLocation: false,
    meta: {
        title: 'Brand home',
        description: 'Opens the operator dashboard/app home for a brand.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [{ name: 'brandId', in: 'path', required: true }],
        example: {
            params: { brandId: 'BXqExampleBrandId' },
            locationId: 'exampleLocationId',
        },
    },
};
//# sourceMappingURL=home.js.map